import { Component, Inject, Optional } from '@angular/core';
import { Router } from '@angular/router';
import { MAT_SNACK_BAR_DATA, MatSnackBar } from '@angular/material/snack-bar';
import {CpNotification} from '../../core/contracts/socket/notification-req';

@Component({
    selector: 'cp-notification',
    templateUrl: './notification.component.html',
    styleUrls: ['./notification.component.scss'],
    standalone: false
})
export class NotificationComponent {
    constructor(
        @Inject(MAT_SNACK_BAR_DATA) public data: CpNotification,
        private snackbar: MatSnackBar,
        @Optional() private router?: Router,
    ) {}

    get iconName(): string {
        const level = this.data.level ?? (this.data.success ? 'success' : 'error');

        switch (level) {
            case 'success':
                return 'task_alt';
            case 'warning':
                return 'warning';
            case 'info':
                return 'info';
            case 'error':
            default:
                return 'cancel';
        }
    }

    get hasAction(): boolean {
        return !!(
            this.data.action?.route ||
            this.data.action?.externalUrl
        );
    }

    get actionLabel(): string {
        return this.data.action?.label?.trim() || 'Details';
    }

    close(): void {
        this.snackbar.dismiss();
    }

    onCloseClick(event: MouseEvent): void {
        event.stopPropagation();
        this.close();
    }

    onContainerClick(): void {
        if (this.hasAction) {
            this.executeAction();
            return;
        }

        this.close();
    }

    onActionClick(event: MouseEvent): void {
        event.stopPropagation();
        this.executeAction();
    }

    private executeAction(): void {
        const action = this.data.action;
        if (!action) {
            this.close();
            return;
        }

        if (action.route && this.router) {
            this.router.navigateByUrl(action.route);
            this.close();
            return;
        }

        if (action.externalUrl) {
            window.open(action.externalUrl, '_blank', 'noopener,noreferrer');
            this.close();
            return;
        }

        this.close();
    }
}